// @flow

import type {
  AITeamSettings,
  ClientServiceAbsenceManagement,
} from "@modules/client/reducer/service/types";

export type ClientServiceState = $Exact<{
  requestsInProgress: number,
  modals: $Exact<{
    addService: $Exact<{
      visible: boolean,
    }>,
  }>,
  service: ClientServiceAbsenceManagement | null,
  aiTeamSettings: AITeamSettings | null,
  schema: Object | null,
}>;

const initialState: ClientServiceState = {
  requestsInProgress: 0,
  modals: {
    addService: {
      visible: false,
    },
  },
  service: null,
  aiTeamSettings: null,
  schema: null,
};

export default initialState;
